import React from "react";

const Blog = () => {
  return (
    <div>
      <h2>Recent Blog Coming Soon </h2>
    </div>
  );
};

export default Blog;
